import { createBrowserHistory } from 'history';
import * as Analytics from './utils/analytics';

const history = createBrowserHistory();

let prevPath = null;

history.listen((location) => {
  // NOTE: this will not update on every query parameter change. if you want that, then this should use
  // location.search as well
  if (location.pathname !== prevPath) {
    prevPath = location.pathname;
    Analytics.page();
  }
});

export default history;
